import * as Service from "../Service";

const fetchReferral = async (tgUserId) => {
  try {
    const referral = await Service.callServer("get", "/api/game/referralCode", {
      tg_user_id: tgUserId,
    });
    console.log(referral);
    if (referral && referral.data) {
      return referral.data;
    }
    throw new Error("Failed to get referral");
  } catch (err) {
    console.error(err);
  }
};

const postReferral = async (tgUserId, referralCode) => {
  try {
    const resp = await Service.callServer("post", "/api/game/postReferral", {
      tg_user_id: tgUserId,
      referral_code: referralCode,
    });
    if (resp && resp.status === 1) {
      return;
    }
    throw new Error("Failed to post referral");
  } catch (err) {
    console.error(err);
  }
};

export { fetchReferral, postReferral };
